/* eslint-disable react/no-danger */
/* eslint-disable react/forbid-dom-props */
/* eslint-disable react/no-children-prop */
import React from 'react'
import { gql } from '@apollo/client'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import { useRouter } from 'next/router'
import RegistrazioneTemplate from '@components/templates/RegistrazioneTemplate/RegistrazioneTemplate'
import { Button } from 'components/atoms'
import { NextWrapper } from 'data-fetching-wrapper'

const RegistrazionePartoripartoPage = ({ pagina }) => {
  const router = useRouter()
  const from = router.query.f && decodeURIComponent(router?.query?.f?.toString())

  const iframeDescription =
    from === 'ariele'
      ? 'Attraverso la partnership con Jointly mettiamo a disposizione consulenze gratuite in ambito Psico-Pedagogico cura di Associazione Ariele'
      : 'Attraverso la partnership con Jointly mettiamo a disposizione consulenze gratuite in ambito giuslavoristico a cura di Patronato acli'

  const titolo = from === 'ariele' ? 'Ariele' : 'Patronato acli'
  const descrizione =
    from === 'ariele'
      ? 'Diventare genitori &egrave; una grande avventura. Per questo ci impegniamo a fornire un supporto concreto a tutte le mamme e pap&agrave; d&rsquo;Italia attraverso una consulenza gratuita con esperti su tematiche legate alla maternit&agrave; e alla paternit&agrave;. Se hai domande di carattere psicologico o pedagogico compila i campi contrassegnati con l&#39;asterisco e clicca su &quot;Avanti&quot; per richiedere la tua consulenza.</p> <p>&nbsp;<br /> Se vuoi anche registrarti al programma &quot;Liberi di diventare Grandi&quot; di Mellin e accedere a tanti contenuti personalizzati, compila il campo &quot;Password&quot;, clicca &quot;Avanti&quot; e compila i dati che ti vengono chiesti nei successivi passaggi, dopo aver letto e spuntato i consensi sulla privacy che trovi sotto il form all&#39;ultimo step di registrazione. <br /></p> '
      : 'Diventare genitori &egrave; una grande avventura. Per questo ci impegniamo a fornire un supporto concreto a tutte le mamme e pap&agrave; d&rsquo;Italia attraverso una consulenza gratuita con esperti su tematiche legate alla maternit&agrave; e alla paternit&agrave;. Se hai domande di natura legale compila i campi contrassegnati con l&#39;asterisco e clicca su &quot;Avanti&quot; per richiedere la tua consulenza.</p> <p>&nbsp;<br /> Se vuoi anche registrarti al programma &quot;Liberi di diventare Grandi&quot; di Mellin e accedere a tanti contenuti personalizzati, compila il campo &quot;Password&quot;, clicca &quot;Avanti&quot; e compila i dati che ti vengono chiesti nei successivi passaggi, dopo aver letto e spuntato i consensi sulla privacy che trovi sotto il form all&#39;ultimo step di registrazione.</p> <p><br />'

  return (
    <>
      <RegistrazioneTemplate
        pagina={{ ...pagina, titolo, descrizione }}
        iframe
        from={from}
        children={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              className="page__description"
              dangerouslySetInnerHTML={{ __html: iframeDescription }}
            />
            <a
              style={{ alignSelf: 'flex-start', marginTop: 15, marginBottom: 15 }}
              href={
                from === 'ariele'
                  ? 'https://www.partoeriparto.mellin.it/partner-ariele/ '
                  : 'https://www.partoeriparto.mellin.it/partner-patronato-acli/'
              }
              target="_blank"
              rel="noreferrer"
            >
              <Button
                variant="primary"
                label={
                  from === 'ariele' ? 'Scopri di più su Ariele' : 'Scopri di più su Patronato Acli'
                }
              />
            </a>
          </div>
        }
      />
    </>
  )
}

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'registrazione-parto-riparto' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina }, // will be passed to the page component as props
    revalidate: 60 * 2, // In seconds
  }
}, '/registrazione-parto-riparto')

export default RegistrazionePartoripartoPage
